import React, { MouseEvent } from "react";
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";

import DB from "_DatabaseFunctions/directConnect";

import DelReqBtn from "app/Components/Buttons/FilledBtns/DelReqBtn.jsx";
import MsgBtn from "app/Components/Buttons/FilledBtns/MsgBtn.jsx";

import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PrimaryTableCell from "app/Components/Tables/PrimaryTableCell";
import StyledTableRow from "app/Components/Tables/StyledTableRow";

function PlayerLists() {
  const navigate = useNavigate();

  const user = useSelector((state: any) => state.user.user);
  const whitelist = useSelector((state: any) => state.host.whitelist);
  const blacklist = useSelector((state: any) => state.host.blacklist);

  const TableHeaders = () => (
    <TableHead>
      <TableRow>
        <PrimaryTableCell align="center">Player Name</PrimaryTableCell>
        <PrimaryTableCell align="center">Options</PrimaryTableCell>
      </TableRow>
    </TableHead>
  );

  const displayTableBody = (list: Record<string, string>, remove: (userId: string, playerId: string) => void) => {
    const playerIds = Object.keys(list);
    return (
      <TableBody>
        {playerIds.map((id) => {
          const playerName = list[id];
          return (
            <StyledTableRow key={id}>
              <PrimaryTableCell
                align="center"
                onClick={() => navigate(`./profile/${id}`)}
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                {playerName}
              </PrimaryTableCell>
              <PrimaryTableCell align="center">
                <MsgBtn userId={id} receiverName={playerName} />
                <DelReqBtn
                  action={() => remove(user.uid, id)}
                  tip="Remove Player"
                />
              </PrimaryTableCell>
            </StyledTableRow>
          );
        })}
      </TableBody>
    );
  };

  const Whitelist = () => (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" component="h2" gutterBottom>
        Whitelist
      </Typography>
      <Typography variant="body2" sx={{ fontStyle: 'italic', mb: 2 }}>
        Players on your Whitelist will automatically be accepted to any of
        your games they send a request.
      </Typography>
      {Object.keys(whitelist).length ? (
        <TableContainer
          component={Paper}
          elevation={5}
        >
          <Table aria-label="customized table">
            {TableHeaders()}
            {displayTableBody(whitelist, DB.removeFromWhitelist)}
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="h6" color="text.secondary" sx={{ my: 2 }}>
          You have nobody on your Whitelist. Add some of your favorite players
          to automatically accept their requests.
        </Typography>
      )}
    </Box>
  );

  const Blacklist = () => (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" component="h2" gutterBottom>
        Blacklist
      </Typography>
      <Typography variant="body2" sx={{ fontStyle: 'italic', mb: 2 }}>
        Players on your Blacklist will automatically be rejected from any of
        your games.
      </Typography>
      {Object.keys(blacklist).length ? (
        <TableContainer component={Paper} elevation={5}>
          <Table>
            {TableHeaders()}
            {displayTableBody(blacklist, DB.removeFromBlacklist)}
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="h6" color="success.main" sx={{ my: 2 }}>
          Great! Nobody on Blacklist
        </Typography>
      )}
    </Box>
  );

  return (
    <Container maxWidth="md">
      <Whitelist />
      <Blacklist />
    </Container>
  );
}

export default PlayerLists;
